<a routerLink="{{navigate}}"
class="group cursor-pointer block overflow-y-hidden no-scrollbar h-[22rem] sm:h-[22rem] xl:h-[22rem] 2xl:h-[22rem] 3xl:h-[25.4rem] hover_div">
  <div class="p-6 3xl:p-8 bg-gray mb-6 3xl:mb-8 border border-light-gray1 bg-card-gray rounded-md 3xl:rounded-lg">
    <img height="150" width="329" loading="lazy" [src]="imageUrl" class="hover_img w-full h-auto rounded-md 3xl:rounded-lg mb-6 3xl:mb-8" alt="{{title}}">
    <div class="h-[8rem] 3xl:h-[8.5rem]">
      <div class="flex items-center gap-2 3xl:gap-2 flex-wrap mb-4 3xl:mb-5">
        <div *ngFor="let tag of tags">
          <app-blog-tag text="{{tag}}" textColor="text-dark-gray2" borderColor="border-dark-gray2"
            borderRadius="rounded-md 3xl:rounded-lg"></app-blog-tag>
        </div>
      </div>
      <p class="text-dark-gray2 text-xs 3xl:text-sm font-medium 3xl:font-semibold mb-1 3xl:mb-2">{{ date }}</p>
      <h3 class="text-lg 3xl:text-2xl font-semibold 3xl:font-bold line-clamp">
        {{ title }}
      </h3>
      
    </div>
  </div>

  <button
    class="text-xs 3xl:text-base flex items-center justify-between font-medium 3xl:font-bold bg-dark-gray1 w-full px-4 3xl:px-5 py-[6px] 3xl:py-2 text-white rounded-md 3xl:rounded-lg duration-500 ease-in-out">
    Read more
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-arrow-right-short"
      viewBox="0 0 16 16">
      <path fill-rule="evenodd"
        d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
    </svg>
  </button>
</a>